import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Information" }), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.33325 8.00001C1.33325 4.32001 4.31992 1.33334 7.99992 1.33334C11.6799 1.33334 14.6666 4.32001 14.6666 8.00001C14.6666 11.68 11.6799 14.6667 7.99992 14.6667C4.31992 14.6667 1.33325 11.68 1.33325 8.00001ZM8.66659 7.33334V11.3333H7.33325V7.33334H8.66659ZM7.99992 13.3333C5.05992 13.3333 2.66659 10.94 2.66659 8.00001C2.66659 5.06001 5.05992 2.66668 7.99992 2.66668C10.9399 2.66668 13.3333 5.06001 13.3333 8.00001C13.3333 10.94 10.9399 13.3333 7.99992 13.3333ZM8.66659 4.66668V6.00001H7.33325V4.66668H8.66659Z",
		fill: "#BDBDBD"
	})]
});
export default SvgInfo;
